import { Box, Divider, Grid, Paper, Typography } from '@mui/material';
import { AppDispatch, RootStateType } from '@Store';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SBDropdown from '@Components/Dropdown';
import { useFormik } from 'formik';
import SbButton from '@Components/Button';
import { onForward } from './constants';
import * as Yup from 'yup';
import Loader from '@Components/Loader';
import { downloadCarrierLabel } from '@Reducers/ShipmentHistory/actions';
import {
  PaymentModeOptions,
  PickupLocationTypeOptions,
  ShippingModeOptions,
} from '../../../ViewSingleShipmentAdmin/components/ShipmentProcessingV2/components/Delhivery/constants';

// ------- VALIDATION SCHEMA -------
const delhiveryInformationSchema = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  accountNo: Yup.mixed()
    .test('is-valid', 'Account is required', (value: any) => {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return true;
      return !!value;
    })
    .required('Account is required'),
  pickup_location: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Pickup location is required'),
  payment_mode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Payment mode is required'),
  shipping_mode: Yup.string()
    .transform(value => (Array.isArray(value) ? '' : value))
    .required('Shipping mode is required'),
});

interface propsTypes {
  onClickForward: () => void;
  onClose?: () => void;
  initialStates: any;
  isEditable?: boolean;
  showFedExDetails: boolean;
  btnText: string;
}

const UserDelhivery = (props: propsTypes) => {
  const { onClickForward, onClose, initialStates, isEditable, showFedExDetails, btnText } = props;
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState<boolean>(false);
  const invoiceNo = useSelector((state: RootStateType) => state.shipment.shipmentById?._packageId.invoiceNumber);
  const { shipmentById, userDelhiveryDetails: userDelhiverySettings } = useSelector(
    (state: RootStateType) => state.shipment,
  );
  const { delhiveryDetails } = useSelector((state: RootStateType) => state.adminShipment);

  // ------------ FORMIK ------------
  const { values, setFieldValue, errors, handleSubmit } = useFormik<any>({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      ...initialStates,
      invoiceNumber: invoiceNo,
      accountNo: userDelhiverySettings?.accountNo?.length
        ? userDelhiverySettings?.accountNo.filter((acc: any) => acc.value.startsWith(initialStates.accountNo))
        : [],
    },
    validationSchema: delhiveryInformationSchema,
    onSubmit(values) {
      onForward({
        values,
        shipmentNumber: shipmentById?.shipmentNumber || '',
        dispatch,
        nextFunc: onClickForward,
        setLoading,
      });
    },
  });

  return (
    <>
      <Loader overly loading={loading}></Loader>
      {showFedExDetails && (
        <Paper
          variant="outlined"
          sx={{
            my: '2rem',
            p: '2rem',
          }}
        >
          <Grid container item xs={12}>
            <Grid container item mb={3}>
              <Grid item xs={12} md={6}>
                <Typography className="font-medium l-text pb-3">Delhivery Information</Typography>{' '}
              </Grid>
            </Grid>
            <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="accountNo"
                    label="Delhivery Account"
                    required
                    placeholder="Select"
                    name="accountNo"
                    value={
                      Array.isArray(values?.accountNo)
                        ? values.accountNo.map((item: { value: any }) => item.value)
                        : values.accountNo
                        ? [values.accountNo]
                        : []
                    }
                    options={userDelhiverySettings?.accountNo ?? []}
                    onChange={(_, selectedObj) => {
                      setFieldValue('accountNo', selectedObj);
                    }}
                    error={errors.accountNo as string}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="pickup_location"
                    label="Pickup location"
                    required
                    placeholder="Select"
                    name="pickup_location"
                    value={values.pickup_location ? [values.pickup_location] : []}
                    options={
                      userDelhiverySettings?.pickup_location?.length
                        ? userDelhiverySettings.pickup_location
                        : PickupLocationTypeOptions
                    }
                    onChange={val => {
                      const selected = val[0] || '';
                      setFieldValue('pickup_location', selected);
                    }}
                    error={errors.pickup_location as string}
                  />
                </Grid>
              </Grid>
              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="payment_mode"
                    label="Payment mode"
                    required
                    placeholder="Select"
                    name="payment_mode"
                    value={values.payment_mode ? [values.payment_mode] : []}
                    options={
                      userDelhiverySettings?.payment_mode?.length
                        ? userDelhiverySettings.payment_mode
                        : PaymentModeOptions
                    }
                    onChange={val => {
                      const selected = val[0] || '';
                      setFieldValue('payment_mode', selected);
                    }}
                    error={errors.payment_mode as string}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="shipping_mode"
                    label="Shipping mode"
                    required
                    placeholder="Select"
                    name="shipping_mode"
                    value={values.shipping_mode ? [values.shipping_mode] : []}
                    options={
                      userDelhiverySettings?.shipping_mode?.length
                        ? userDelhiverySettings.shipping_mode
                        : ShippingModeOptions
                    }
                    onChange={val => {
                      const selected = val[0] || '';
                      setFieldValue('shipping_mode', selected);
                    }}
                    error={errors.shipping_mode as string}
                  />
                </Grid>
              </Grid>

              <Divider className="mt-3 mb-3" />
              <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
                <Grid container item sx={{ gap: '1rem' }}>
                  <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                    <SbButton
                      disabled={!isEditable}
                      variant="contained"
                      sx={{ borderRadius: '4px !important' }}
                      className="w-full"
                      onClick={_event => {
                        handleSubmit();
                      }}
                    >
                      {btnText}
                    </SbButton>
                  </Grid>
                  {onClose && (
                    <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                      <SbButton
                        sx={{ borderRadius: '4px !important' }}
                        className="w-full"
                        variant="outlined"
                        onClick={onClose}
                      >
                        Cancel
                      </SbButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      )}
      {delhiveryDetails?.response && (
        <Grid container item>
          <Grid item xs={'auto'} border={'1px solid'} className="border-grey font-medium md-text p-2" borderRadius={1}>
            This shipment has been forwarded.
            <Box
              component={'span'}
              className="font-medium md-text ml-1"
              sx={{
                color: '#485fc7',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => {
                if (shipmentById?.shipmentNumber) {
                  dispatch(downloadCarrierLabel(shipmentById?.shipmentNumber));
                }
              }}
            >
              Download the carrier AWB
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default UserDelhivery;
